// Honours the user's OS-level "reduce motion" preference. Guarded with optional chaining
// because jsdom (test env) does not implement window.matchMedia.
export function prefersReducedMotion(): boolean {
	return window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches ?? false;
}

// Scroll behavior that collapses to an instant jump when the user prefers reduced motion.
export function scrollBehavior(): ScrollBehavior {
	return prefersReducedMotion() ? "auto" : "smooth";
}
